function showMenuContent(blockId) {
    const allBoneButtons = document.querySelectorAll('.bone');
    const allBlocks = document.querySelectorAll('.collection-item-container');

    allBoneButtons.forEach(button => button.classList.remove('active'));

    const selectedButton = document.querySelector(`.bone[onclick="showMenuContent('${blockId}')"]`);
    if (selectedButton) {
        selectedButton.classList.add('active');
        selectedButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    allBlocks.forEach(block => block.style.display = 'none');

    const selectedBlock = document.querySelector(`.collection-item-container[data-block-id="${blockId}"]`);
    if (selectedBlock) {
        selectedBlock.style.display = 'block';
    }
}